import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			selectedImageIndex: undefined,
			units: []
		};
	},
	// props: {
	// 	filter: Object,
	// 	sorting: String,
	// 	max: String
	// },
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}
		var objektGroupId;
		let el = document.querySelector("[groupid]");
		console.log("el.getAttribute('groupid')::" + el.getAttribute('groupid'));
		if (el) {
			objektGroupId = parseInt(el.getAttribute('groupid'), 10);
		} else {
			console.log('element is not found..................');
		}
		console.log('objektGroupId::::' + objektGroupId);

		var req = {
			fields: this.resultFields,
			filter: {
				unitgroupid: objektGroupId
			},
			max: 120,
			sorting: 'random'
		};


		doReq('searchUnits', req)
			.then((res) => {
				this.units = res.units;

			});


	},
	updated: function () {
		//this.applySlider();
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();
	},
	methods: {
		getUnitSearchTarget: function (id) {
			if (window.screen.width < 768) {
				//probably phone?
				return '_self';
			} else {
				return 'unit_' + id;
			}
		},


		applySlider: function () {
			$(".owl-carousel.similar-units").owlCarousel({
				loop: false,
				margin: 30,
				smartSpeed: 3000,
				autoplay: false,
				nav: true,
				responsive: {
					0: {
						items: 1
					},
					768: {
						items: 2
					},
					996: {
						items: 3
					},
					1200: {
						items: 4

					}
				}
			});

			$(".owl-carousel.feedback-slide").owlCarousel({
				loop: false,
				items: 1,
				margin: 30,
				smartSpeed: 3000,
				autoplay: false,
				nav: true
			});
		}
	}

};